import $ from 'jquery';

// Expose jQuery $-shorthand, since the tracking container relies on it
window.$ = $;

initDataLayer();
injectTagCommanderContainer();

function initDataLayer() {
  let siteHierarchy = $('#site-hierarchy');

  window.tc_vars = {
    env_template: pageDataLayer.dataLayerIdentifier,
    env_work: pageDataLayer.envWork, // variable, Integ System='preprod'; live System='prod'
    env_country: pageDataLayer.language.toUpperCase(),
    env_device: getCookie('deviceType'),
    env_language: pageDataLayer.language,
    page_cat_id: pageDataLayer.pageCatId, // UID of page from pageDataLayer
    page_cat1: pageDataLayer.dataLayerIdentifier,
    page_cat2: siteHierarchy.find('span:nth-child(2)').text(), // use #site-hierarchy
    page_cat3: siteHierarchy.find('span:nth-child(3)').text(), // use #site-hierarchy
    page_cat4: siteHierarchy.find('span:nth-child(4)').text(), // use #site-hierarchy
    page_cat5: siteHierarchy.find('span:nth-child(5)').text(), // use #site-hierarchy
    page_name: pageDataLayer.dataLayerIdentifier, // use #site-hierarchy
  };
}

// Load TagCommander Container: The Data Layer needs to be filled with information before the TagCommander Container file is loaded
function injectTagCommanderContainer() {
  if (typeof window.pageDataLayer.tagCommanderContainer !== 'undefined' && window.pageDataLayer.tagCommanderContainer !== '') {
    $.getScript(window.pageDataLayer.tagCommanderContainer).done(initTrackingFeatures);
  }
}

function initTrackingFeatures() {
  updateElementTrackingDataAttributes();
  addTrackingDataJobPostingText();
  trackFileUploadError();
  trackJobFilterOptions();
  trackJobFilterClose();
  trackSelectedReferenzmedienOnSubmitInJobApplicationForm();
}

function trackSelectedReferenzmedienOnSubmitInJobApplicationForm() {
  $(document).on('ValidatedFormView.send', '#form-jobApplication', (event) => {
    const $referenzmedienSelectField = $(event.target).find('select#form-input-referenzmedien');
    if ($referenzmedienSelectField.length === 0) {
      return;
    }

    const selectedOption = $referenzmedienSelectField.find('option:selected');
    if (!selectedOption.val()) {
      return;
    }
    try {
      tC.event.click_on_element(event, {kategorie: 'Aufmerksamkeit', name: selectedOption.text()});
    } catch (error) {
      console.error('Error tracking click_on_element:', error);
    }
  });
}

function trackJobFilterOptions() {
  const $filterOffCanvas = $('#off-canvas-menu-job-postings-filter');
  let lastEventData = null;

  if ($filterOffCanvas.length === 0) {
    return;
  }

  $filterOffCanvas.on('closed.offcanvas', () => {
    const eventData = $filterOffCanvas.find('form').data('tracking-event-data') || null;
    if (!eventData) {
      return;
    }
    // eventData is empty array if empty filters are selected, otherwise an object
    if (Array.isArray(eventData) === false && JSON.stringify(eventData) !== JSON.stringify(lastEventData)) {
      try {
        tC.event.click_on_jobfilter(event, eventData);
      } catch (error) {
        console.error('Error tracking click_on_jobfilter:', error);
      }
      lastEventData = eventData;
    }
  });
}

function trackJobFilterClose() {
  const $filterOffCanvas = $('#off-canvas-menu-job-postings-filter');
  if ($filterOffCanvas.length === 0) {
    return;
  }

  $filterOffCanvas.on('closed.offcanvas', () => {
    try {
      tC.event.click_on_element(event, {kategorie: window.tC.internalvars.page_category_path, name: 'Filter_schließen'});
    } catch (error) {
      console.error('Error tracking click_on_element:', error);
    }
  });
}

function updateElementTrackingDataAttributes() {
  $('[data-ef-tcetype="element"][data-ef-tcedata]').each((index, element) => {
    const $element = $(element);
    const tcedata = JSON.parse($element.attr('data-ef-tcedata'));

    if ('kategorie' in tcedata && tcedata.kategorie === '__js__page_category_path') {
      // Update value for "kategorie" in "data-ef-tcedata" Attribute
      tcedata.kategorie = window.tC.internalvars.page_category_path;
      $element.attr('data-ef-tcedata', JSON.stringify(tcedata));
    }
  });
}

function addTrackingDataJobPostingText() {
  // add tracking data attributes to email and telephone links in text of job detail pages
  $('[data-jobs-tracking-email-tel]').each((index, element) => {
    const $element = $(element);
    const tel = $element.find('a[href^="tel:"]');
    const email = $element.find('a[href^="mailto:"]');

    if (tel.length > 0) {
      tel.attr('data-ef-tcetype', 'element');
      tel.attr('data-ef-tcedata', JSON.stringify({kategorie: window.tC.internalvars.page_category_path, name: 'Telefonnummer'}));
    }
    if (email.length > 0) {
      email.attr('data-ef-tcetype', 'element');
      email.attr('data-ef-tcedata', JSON.stringify({kategorie: window.tC.internalvars.page_category_path, name: 'E-Mail-Adresse'}));
    }
  });
}

function trackFileUploadError() {
  $(document).on('jobApplicationForm:removeFileUpload', function (event) {
    const $target = $(event.target);
    const fileFieldHasError = $target.closest('.form-group-file').hasClass('has-error');

    if (fileFieldHasError) {
      try {
        tC.event.click_on_element(event, {kategorie: window.tC.internalvars.page_category_path, name: 'Fehlermeldung_schließen'});
      } catch (error) {
        console.error('Error tracking click_on_element:', error);
      }
    }
  });
}

function getCookie(name) {
  const cookies = document.cookie;
  const value = '; ' + cookies;
  let parts = value.split('; ' + name + '=');

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
}
